<script lang="ts">
  let { text }: { text: string } = $props();
</script>

<h3 class="mb-3 ml-2 text-label-xs font-bold uppercase">{text}</h3>
